import { colors, fonts } from '../theme'

export default function MetricCard({ label, value, sublabel, sentiment: sentimentType }) {
  const sentimentColor = sentimentType === 'positive' ? colors.greenInk
    : sentimentType === 'negative' ? colors.redInk
    : sentimentType === 'accent' ? colors.gold
    : colors.textPrimary

  return (
    <div style={styles.card}>
      <span style={styles.label}>{label}</span>
      <span style={{ ...styles.value, color: sentimentColor }}>{value}</span>
      {sublabel && <span style={styles.sublabel}>{sublabel}</span>}
    </div>
  )
}

const styles = {
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    padding: '12px 16px',
    background: colors.navySurface,
    border: `1px solid ${colors.rule}`,
    borderRadius: 3,
    minWidth: 140,
  },
  label: {
    fontFamily: fonts.serif,
    fontSize: 11,
    fontStyle: 'italic',
    textTransform: 'uppercase',
    color: colors.textMuted,
    letterSpacing: 0.5,
  },
  value: {
    fontFamily: fonts.mono,
    fontSize: 18,
    fontWeight: 600,
    color: colors.textPrimary,
  },
  sublabel: {
    fontFamily: fonts.mono,
    fontSize: 11,
    color: colors.textMuted,
  },
}
